import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPropertyDocumentsQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetPropertyDocumentsQuery = { __typename?: 'query_root', property_documents: Array<{ __typename?: 'property_documents', id: any, name?: string | null, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed?: boolean | null, type?: string | null, description?: string | null }> };


export const GetPropertyDocumentsDocument = gql`
    query getPropertyDocuments($id: uuid!) {
  property_documents(
    where: {property_id: {_eq: $id}}
    order_by: {created_at: desc}
  ) {
    id
    name
    photo_link
    document_link
    video_link
    audio_link
    site_link
    transcription
    transcribed
    type
    description
  }
}
    `;

/**
 * __useGetPropertyDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPropertyDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPropertyDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables> & ({ variables: GetPropertyDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>(GetPropertyDocumentsDocument, options);
      }
export function useGetPropertyDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>(GetPropertyDocumentsDocument, options);
        }
export function useGetPropertyDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>(GetPropertyDocumentsDocument, options);
        }
export type GetPropertyDocumentsQueryHookResult = ReturnType<typeof useGetPropertyDocumentsQuery>;
export type GetPropertyDocumentsLazyQueryHookResult = ReturnType<typeof useGetPropertyDocumentsLazyQuery>;
export type GetPropertyDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetPropertyDocumentsSuspenseQuery>;
export type GetPropertyDocumentsQueryResult = Apollo.QueryResult<GetPropertyDocumentsQuery, GetPropertyDocumentsQueryVariables>;